import { Content } from "../tree/content";
import { Site } from "../tree/site";
import { Aspect } from "../tree/aspect";
import { Prototype } from "../tree/prototype";
import { PrototypeModel } from "./prototype-model";
import { ContentModel } from "./content-model";
import { Folder, Genus } from "../tree/genus";

export class ViewFields {
    readonly prototypeModel?: PrototypeModel;
    readonly contentModel?: ContentModel;

    constructor(content: Content | Site, custome: any, prototypes: Map<string, Prototype>, aspects?: Map<string, Aspect>) {
        if (prototypes && content.prototypeId) {
            const prototype = prototypes.get(content.prototypeId);
            this.prototypeModel = new PrototypeModel(prototype!);

            if (aspects?.size) {
                const selected: Aspect[] = [];

                if (content.parent instanceof Genus && content.parent.aspects?.length) {
                    selected.push(
                        ...content.parent.aspects
                            .map(id => aspects.get(id))
                            .filter((x): x is Aspect => !!x)
                    );
                }

                if (content.parent instanceof Folder) {
                    const inherit = content.parent.inheritAspects;
                    if (inherit?.length) {
                        selected.push(
                            ...inherit
                                .map(id => aspects.get(id))
                                .filter((x): x is Aspect => !!x)
                        );
                    }
                }

                this.prototypeModel.load(...selected);
            }

            this.contentModel = new ContentModel(
                this.prototypeModel,
                content,
                custome
            );
        }
    }
}
